// extracted by mini-css-extract-plugin
export default {"streamControlsContainer":"Stream_streamControlsContainer__q8FMn","largeVideoContainer":"Stream_largeVideoContainer__Adxzy","invisible":"Stream_invisible__BqDf+"};